import { queryOptions, useQuery } from '@tanstack/react-query';

import { getAllFaqs, getFaqById, getFaqsByType } from '@/lib/api/faq';

import { queryKeys } from './query-keys-factory';

/**
 * Query Options Factories
 */
export const faqQueries = {
  /**
   * Get all FAQs
   */
  all: () =>
    queryOptions({
      queryKey: queryKeys.faqs.list(),
      queryFn: getAllFaqs,
      staleTime: 1000 * 60 * 10, // 10 minutes
      retry: false,
    }),

  /**
   * Get FAQs by type (piercing or tattoo)
   */
  byType: (type: 'piercing' | 'tattoo') =>
    queryOptions({
      queryKey: queryKeys.faqs.list({ type }),
      queryFn: () => getFaqsByType(type),
      staleTime: 1000 * 60 * 10,
      retry: false,
    }),

  /**
   * Get FAQ by ID
   */
  byId: (id: string) =>
    queryOptions({
      queryKey: queryKeys.faqs.detail(id),
      queryFn: () => getFaqById(id),
      staleTime: 1000 * 60 * 10,
      enabled: !!id,
      retry: false,
    }),
};

/**
 * Query Hooks
 */

/**
 * Hook to fetch all FAQs
 */
export const useGetAllFaqs = () => useQuery(faqQueries.all());

/**
 * Hook to fetch FAQs by type
 */
export const useGetFaqsByType = (type: 'piercing' | 'tattoo') => useQuery(faqQueries.byType(type));

/**
 * Hook to fetch FAQ by ID
 */
export const useGetFaqById = (id: string) => useQuery(faqQueries.byId(id));
